export default {
    methods: {
        /**
         * Translate the given key.
         */
        __(key, replace = {}) {
            // Get the translation object from Inertia props
            const translations = this.$page.props.i18n || {};
            
            // Split the key into parts for nested access
            const keys = key.split('.');
            let translation = translations;
            
            // Navigate through nested object using the keys
            for (const keyPart of keys) {
                if (translation && typeof translation === 'object' && translation.hasOwnProperty(keyPart)) {
                    translation = translation[keyPart];
                } else {
                    // If key not found, return the original key
                    return key;
                }
            }
            
            // If we don't have a string at the end, return the key
            if (typeof translation !== 'string') {
                return key;
            }

            // Replace placeholders with values
            Object.keys(replace).forEach(function (replaceKey) {
                translation = translation.replace(':' + replaceKey, replace[replaceKey]);
            });

            return translation;
        },

        /**
         * Translate the given key with basic pluralization.
         */
        __n(key, number, replace = {}) {
            const options = key.split('|');

            let selectedKey = options[1]; // plural form
            if (number == 1 && options[0]) {
                selectedKey = options[0]; // singular form
            }

            return this.__(selectedKey, replace);
        },
    },
}